/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rooms_TotalInputs */



/**
* | output |
* | --- |
* | "{count} tables" |
*
* @param {Rooms_TotalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_total = /** @type {((inputs: Rooms_TotalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_TotalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} tables`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} mesas`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} mesas`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} tavoli`)
	return /** @type {LocalizedString} */ (`${i?.count} tables`)
});